module.exports = __webpack_public_path__ + "media/images/wishCollectorLogoOfficial-e18c3b48.png";